module.exports = __webpack_public_path__ + "img/logowatch.0b3c0760.png";